import { getApi } from '../../components/Shared/shared';
const baseURL = getApi();

export const ingredientSetUrls = {
  ingredientSets: `${baseURL}/ingredient-sets`
};

export default ingredientSetUrls;
